import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Es seguro?',
  a: 'Sí, se basa en alimentos reales y técnicas de hidratación natural.'
}, {
  q: '¿Pasaré hambre?',
  a: 'No, el plan incluye proteínas saciantes que evitan los picos de insulina.'
}, {
  q: '¿Tengo que comprar suplementos caros?',
  a: 'No, todo lo que necesitas está en cualquier supermercado.'
}, {
  q: '¿Tengo acceso de por vida?',
  a: 'Sí, una vez que descargas el PDF es tuyo para siempre.'
}];
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-16 md:py-24 px-4 bg-cream" data-id="element-28">
      <div className="max-w-3xl mx-auto" data-id="element-29">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-30">
          <h2 className="text-3xl md:text-4xl font-bold text-forest mb-4" data-id="element-31">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-32">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-white rounded-2xl shadow-sm border border-forest-50 overflow-hidden" data-id="element-33">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-34">
                <span className="font-bold text-charcoal text-lg" data-id="element-35">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-forest transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-36" />
              </button>

              <AnimatePresence data-id="element-37">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-38">
                    <div className="px-6 pb-5 text-charcoal-light border-t border-gray-50 pt-3" data-id="element-39">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}